const APP_AIRLINES = [
  "Sichuan Airlines (3U)", "Aegean Airlines (A3)", "American Airlines (AA)",
  "Bonza Aviation (AB)", "Air Canada (AC)", "Air France (AF)", "Air India (AI)",
  "Aeromexico (AM)", "Aerolineas Argentinas (AR)", "Avianca (AV)", "Finnair (AY)",
  "ITA Airways (AZ)", "British Airways (BA)", "EVA Air (BR)", "Air China (CA)",
  "China Airlines (CI)", "Copa Airlines (CM)", "Cathay Pacific (CX)",
  "China Southern Airlines (CZ)", "Delta Air Lines (DL)", "Emirates (EK)",
  "Ethiopian Airlines (ET)", "Shanghai Airlines (FM)", "Fuzhou Airlines (FU)",
  "Garuda Indonesia (GA)", "Tianjin Airlines (GS)", "Juneyao Airlines (HO)",
  "Hainan Airlines (HU)", "Hong Kong Airlines (HX)", "Iberia (IB)",
  "Beijing Capital Airlines (JD)", "TAM Airlines (JJ)", "Japan Airlines (JL)",
  "Adria Airways (JP)", "STARLUX Airlines (JX)", "Korean Air (KE)",
  "KLM Royal Dutch Airlines (KL)", "Kenya Airways (KQ)", "LATAM Airlines (LA)",
  "Lufthansa (LH)", "LOT Polish Airlines (LO)", "SWISS (LX)",
  "Middle East Airlines (ME)", "Xiamen Airlines (MF)", "Malaysia Airlines (MH)",
  "EgyptAir (MS)", "China Eastern Airlines (MU)", "All Nippon Airways (NH)",
  "Air Macau (NX)", "Air New Zealand (NZ)", "Avianca Brasil (O6)",
  "Austrian Airlines (OS)", "Croatia Airlines (OU)", "Asiana Airlines (OZ)",
  "Philippine Airlines (PR)", "Qantas Airways (QF)", "Qatar Airways (QR)",
  "Royal Jordanian (RJ)", "Tarom (RO)", "S7 Airlines (S7)",
  "South African Airways (SA)", "Shandong Airlines (SC)",
  "Scandinavian Airlines (SK)", "Brussels Airlines (SN)",
  "Singapore Airlines (SQ)", "Aeroflot (SU)", "Saudia (SV)",
  "Thai Airways (TG)", "Turkish Airlines (TK)", "TAP Air Portugal (TP)",
  "Tibet Airlines (TV)", "United Airlines (UA)", "SriLankan Airlines (UL)",
  "Air Europa (UX)", "Virgin Australia (VA)", "Vietnam Airlines (VN)",
  "Suparna Airlines (Y8)", "Shenzhen Airlines (ZH)",
];

export const frequentFlyerAirlines = APP_AIRLINES.map((label) => {
  const match = label.match(/^(.*) \(([A-Z0-9]{2})\)$/);
  return { label, name: match?.[1] || label, code: match?.[2] || "" };
});

export const frequentFlyerAirlineByCode = new Map(
  frequentFlyerAirlines.map((airline) => [airline.code, airline])
);

export const emptyFrequentFlyerMembership = () => ({
  airlineName: "",
  airlineCode: "",
  membershipNumber: "",
});

export const normalizeFrequentFlyerMembership = (membership = {}) => {
  const airline = frequentFlyerAirlineByCode.get(String(membership.airlineCode || "").toUpperCase()) ||
    frequentFlyerAirlines.find((item) => item.name === membership.airlineName);
  return {
    airlineName: airline?.name || membership.airlineName || "",
    airlineCode: airline?.code || String(membership.airlineCode || "").toUpperCase(),
    membershipNumber: String(membership.membershipNumber || ""),
  };
};
